/**
 * Created by lihanying on 2017/7/1.
 */
import React from 'react'
import { Checkbox, Row, Col } from 'antd'

export default class extends React.Component {

  render() {
    const { record, walletType } = this.props
    const access = walletType.list && walletType.list.map(item => {
      let state
      if (item.access == 1) {
        state = item.id
        return state
      }
    })

    return (
      <div style={{ marginBottom: '2rem' }}>
        <h3 style={{ padding: '1rem 0 1rem 0' }}>设置钱包在这张桌台是否可以消费</h3>
        <Checkbox.Group defaultValue={access} onChange={(value) => this.props.handleCheckbox(value)}>
          <Row>
            {walletType.list && walletType.list.map((item, idx) => {
              return (
                <Col span={8} key={idx}><Checkbox value={item.id}>{item.name}</Checkbox></Col>
              )
            })}
          </Row>
        </Checkbox.Group>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/market.js